
import { selectMe } from 'app/slice/user.slice'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** CONSTANT */
import { Icons } from 'constants/images'

/** COMPONENT */
import CardAppointment from 'component/Appointment/CardAppointment'
import Loading from 'component/Loading'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import TextAreaInput from 'new-components/inputs/text-area-input'
import SectionAppointment from 'component/Appointment/GraphAppointment'
import CollapseContainer from 'component/Collapse/container'
import SectionFilterDoctor from 'component/Home/filterDoctor'
import SendExamination from 'component/Register/SendExamination'
import SectionFilterPatient from 'features/home/filterPatient'
import SectionServicePoints from 'features/home/sliderServicePoints'

/** CONSTANTS */
import { colors } from 'constants/theme'

/** UTILS || SLICE */
import { checkAddons, getBranch, numberFormat, toBuddhistYear } from 'utils/app.utils'

/** API */
import BaseAPI from 'api/api'
import HomeApi from 'api/home/home.api'
import BranchApi from 'api/setting/branch-service-points/branch.api'
import { routeName } from 'routes/routes-name'

import SendExaminationApi from 'api/master/sendExamination.api'

/** STYLE */
import AboutUs from 'api/admin/clinic-manage/about.api'
import RegisterApi from 'api/counter/register.api'
import OperativeApi from 'api/setting/treatments/operative.api'
import { swalCustom } from 'component/Alert/Swal'
import CardAppointmentDetail from 'component/Appointment/CardAppointmentDetail'
import { AppointmentCardItemDayInterface } from 'features/counter/appointment/appointment-interface'
import * as UseStyled from 'features/home/UseStyled'
import { PACKAGE_ADDONS } from 'constants/package'

interface DisplayPageInterface {
  displayPageId: number
  branchId: number
  pageNumber: number
  pageName: string
  pageNameEn: string
  sorting: number
  servicePointCount: number
}

export default function Home() {
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const user = useSelector(selectMe)
  let countAp = 0
  let checkTimeStart = '';
  const [timeRange, setTimeRange] = useState<any>([])
  const [appointments, setAppointments] = useState<any>([])
  const [doctors, setDoctors] = useState<any>(null)
  const [temps, setTemps] = useState([])
  const [doctor, setDoctor]: any = useState({})
  const [hasCollapse, setHasCollapse] = useState(false)
  const [canViewIncome, setCanViewIncome] = useState(false)
  const [income, setIncome] = useState(0)
  const [servicePoints, setServicePoints] = useState([])
  const [sendExam, setSendExam] = useState(false)
  const [patientCase, setPatientCase] = useState<any | null>([])
  const [clinicIsClose, setClinicIsClose] = useState(false);
  const [viewDetails, setViewDetails] = useState([])
  const branchId = getBranch()
  const [branch, setBranch] = useState<any>()
  const [key, setkey] = useState({ nonUsedKey: 0 })
  const [dateHome, setDateHome] = useState<string>('')
  const [selectAppoinment, setSelectAppoinmente] = useState<any>('')
  // initial-load only — ไม่ใช้กับ background refresh เพื่อไม่ให้หน้าจอกระพริบทุกครั้ง SSE/dataAlert update
  const [isInitialLoading, setIsInitialLoading] = useState(true)

  // Display Pages state
  const [displayPages, setDisplayPages] = useState<DisplayPageInterface[]>([])
  const [selectedPage, setSelectedPage] = useState<number>(0) // 0 = ทั้งหมด

  // ยอดค้างชำระก่อนส่งตรวจ (เปิด modal ข้ามการชำระ)
  const [isOpenOverdueModal, setIsOpenOverdueModal] = useState(false)
  const [overdueRemark, setOverdueRemark] = useState('')
  const [overduePatientId, setOverduePatientId] = useState<number | null>(null)
  const [overdueOutstandingBalance, setOverdueOutstandingBalance] = useState<number>(0)
  // แจ้งยอดค้างชำระแบบบังคับ (openNotification === '1') - UI เดียวกับหน้าลงทะเบียน
  const [isOpenOverdueAlert, setIsOpenOverdueAlert] = useState(false)
  const [overdueAlertPatientId, setOverdueAlertPatientId] = useState<number | null>(null)
  const [overdueAlertBalance, setOverdueAlertBalance] = useState<number>(0)
  const [pendingAfterOverdue, setPendingAfterOverdue] = useState<{ type: 'appointment'; appointmentId: number } | { type: 'queue'; patientCase: any } | null>(null)

  // 1 visit ข้ามค้างจ่ายได้แค่ครั้งเดียว หลังข้ามแล้วส่งตรวจได้ปกติ (เก็บว่า patient ไหนข้ามไปแล้วใน session นี้)
  const skippedOverduePatientIdsRef = useRef<Set<number>>(new Set())

  // In-flight dedup: ถ้า load fn เดิมยังรันอยู่ การเรียกซ้ำจะ reuse promise เดิม ไม่ยิง API ซ้ำ
  // ครอบคลุม: mount เรียกหลาย effect พร้อมกัน, SSE flush ตรงกับ reRender callback, dataAlert change ตรงกับ event อื่น
  const inFlightRef = useRef<Record<string, Promise<any> | undefined>>({})
  const dedupe = <T,>(key: string, fn: () => Promise<T>): Promise<T> => {
    const existing = inFlightRef.current[key] as Promise<T> | undefined
    if (existing) return existing
    const p = fn().finally(() => {
      if (inFlightRef.current[key] === p) inFlightRef.current[key] = undefined
    })
    inFlightRef.current[key] = p
    return p
  }

  // O(1) lookup maps แทน _.find ใน loop เพื่อลดเวลา render เมื่อมี doctor/appointment เยอะ
  const tempsByDoctorId = useMemo(() => {
    const map = new Map<number, any>()
    _.forEach(temps as any[], (t: any) => { if (t?.doctorId != null) map.set(t.doctorId, t) })
    return map
  }, [temps])

  const viewDetailSet = useMemo(() => new Set<number>(viewDetails as number[]), [viewDetails])

  const loadBranchInfo = () => {
    AboutUs.detailClinic(Number(branchId))
      .then(({ data }) => {
        setBranch(data)
      })
      .catch((e) => { return })
  }

  useEffect(() => {
    loadBranchInfo()
  }, [branchId])

  const loadIncome = () => dedupe('income', async () => {
    if (!_.isEmpty(user) && user.hasViewIncome === 'PERMISS') {
      const respIncome = await HomeApi.clinicIncome()

      if (respIncome.status === 200) {
        setIncome(respIncome.data || 0)
        setCanViewIncome(true)
      }
    } else {
      setIncome(0)
      setCanViewIncome(false)
    }
  })

  const loadDisplayPages = async () => {
    try {
      const resp = await HomeApi.getDisplayPages()
      if (resp.status === 200 && resp.data && resp.data.length > 0) {
        setDisplayPages(resp.data)
      }
    } catch (e) {
      console.log('Error loading display pages:', e)
    }
  }

  const loadListQueue = () => dedupe('listQueue', async () => {
    try {
      let queue
      // ถ้ามีหลายชั้นและเลือกชั้นแล้ว (ไม่ใช่ทั้งหมด) ให้โหลดตามชั้นที่เลือก
      if (displayPages.length > 1 && selectedPage > 0) {
        queue = await HomeApi.listQueueByPage(selectedPage)
      } else {
        queue = await HomeApi.listQueue()
      }
      if (queue.status === 200 && !_.isEmpty(queue.data)) setServicePoints(queue.data)
      else setServicePoints([])
    } catch (e) {
      setServicePoints([])
    }
  })

  const loadAllAppointment = () => dedupe('allAppointment', async () => {
    const respAppointments = await HomeApi.allAppointment()
    if (respAppointments.status === 200 && !_.isEmpty(respAppointments.data)) {
      setAppointments(respAppointments.data)
    }
    else setAppointments([])
  })

  const loadAllDentists = () => dedupe('allDentists', async () => {
    const selectDoc = doctor

    const dentists = await HomeApi.allDentists()
    setkey({ nonUsedKey: Date.now() })
    if (dentists.status === 200 && !_.isEmpty(dentists.data)) {
      setDoctors(dentists.data)
      setTemps(_.clone(dentists.data))


      if (_.isEmpty(doctor)) { return setDoctor(dentists.data[0]) }
      if (doctor) {

        const item = _.find(dentists.data, { doctorId: selectDoc.doctorId })
        if (item) setDoctor(item)
      }

    } else {
      setDoctor({})
      setDoctors([])
      setTemps([])
    }
  })

  const openVisitAppointment = async (id: number) => {
    const visit = await SendExaminationApi.homeOpenVisit(id)
    if (visit.status === 201 && !_.isEmpty(visit.data)) {
      setPatientCase(visit.data)
      setSendExam(true)
    } else setPatientCase([])
  }

  const onSendToRegister = (data: any) => {
    history.push({
      pathname: routeName.register,
      state: { newPatientInfo: data }
    })
  }

  const onSendToRegisterPatientId = (data: any, treatment?: any) => {
    history.push({
      pathname: routeName.register,
      state: { patientId: data, treatment: treatment }
    })
  }


  const FALLBACK_TIME_RANGE = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']

  const handleTimeBranch = (branchId: number) => {
    if (!branchId) {
      // ไม่มี branchId — ใช้ default ไว้ก่อน เพื่อให้ตารางนัดยังวาดได้
      setTimeRange(FALLBACK_TIME_RANGE)
      return Promise.resolve()
    }
    return dedupe(`timeBranch-${branchId}`, async () => {
      try {
        const { data } = await BranchApi.findById(branchId)
        const day = _.find(data.officeTimes, (time) => time.dayOfWeek === moment().locale('en').format('ddd'))
        if (day?.officeStatus === 'CLOSE') setClinicIsClose(true)
        let start: any = moment(day?.timeIn, 'HH:mm')
        let end: any = moment(day?.timeOut, 'HH:mm')
        if (parseInt(start.format('mm')) > 0) start = moment(data.timeIn, 'HH:mm').startOf('hour')
        if (parseInt(end.format('mm')) > 0) end = moment(data.timeOut, 'HH:mm').endOf('hour').add(1, 'minute')
        const timeEnd = parseInt(end.format('HH')) === 0 ? 24 : parseInt(end.format('HH'))
        const range: any = []
        for (let index = parseInt(start.format('HH')); index <= timeEnd; index++) {
          range.push(`${String(index).padStart(2, '0')}:00`)
        }
        if (!_.isEmpty(range)) setTimeRange(range)
        else setTimeRange(FALLBACK_TIME_RANGE)
      } catch (e) {
        // API fail — fallback เพื่อไม่ให้ตารางนัดหายทั้งฝั่ง
        console.warn('handleTimeBranch failed, using fallback range', e)
        setTimeRange(FALLBACK_TIME_RANGE)
      }
    })
  }

  const handleSelectAppoinment = (val: any) => {
    countAp = 0
    checkTimeStart = ''
    if (val.appointmentId) {
      setSelectAppoinmente(val.timeStart)
      const dr: any = tempsByDoctorId.get(val.doctorId)
      const apt = _.filter(dr?.appointments, { appointmentId: Number(val.appointmentId) })
      setDoctor({ ...(dr || {}), ...{ appointments: apt } })
    } else {
      setDoctor(temps[0])
    }
  }

  const handleSelectDoctor = (event: any) => {
    countAp = 0
    checkTimeStart = ''
    const id = event.target.value || event.target.offsetParent.value || event.target.alt
    const item = tempsByDoctorId.get(Number(id))
    if (id && item) setDoctor(item)
  }

  const handleCollapse = (status: boolean) => {
    setHasCollapse(status)
  }

  const handleCallback = (value: any) => {
    if (value.key === 'openVisit') {
      const patientCase = value.value
      const pid = patientCase?.patientId
      if (!branch?.openNotification || !pid) {
        setPatientCase(patientCase)
        setSendExam(true)
        return
      }
      RegisterApi.findPatientFinanceByPatientId(pid).then((resp) => {
        const outstanding = resp.data?.outstandingBalance ?? 0
        if (outstanding <= 0) {
          setPatientCase(patientCase)
          setSendExam(true)
          return
        }
        if (branch?.openNotification === '1') {
          swalCustom(
            `${t('REGISTER.ALERT.NOTIFICATION_OVERDUE')}`,
            `<div>
              <div class="pt-2" style="padding-top: 16px; display: flex; flex-direction: column; gap: 0;">
                <div style="margin: 0; padding: 0;">${t('REGISTER.ALERT.PLEASE_PAY_OVERDUE_AMOUNT')}</div>
                <p style="margin: 0; padding: 0;">${t('REGISTER.ALERT.PRESS')} <strong>"${t('REGISTER.ALERT.CONFIRM')}"</strong>${t('REGISTER.ALERT.TO_CONTINUE')}</p>
              </div>
              <div class="pt-2" style="text-align: left; padding-top: 16px;" color="#FB5252">
                <span><strong>${t('REGISTER.ALERT.TOTAL_OVERDUE_AMOUNT')} </strong> &nbsp;${numberFormat(outstanding)}&nbsp; <strong>${t('REGISTER.ALERT.BAHT')}</strong></span>
              </div>
            </div>`,
            (res: any) => { if (res) history.push(routeName.overdueDetail, { patientId: pid }) },
            'warning',
            { confirmButton: { confirmButtonText: t('BUTTON.SUBMIT') }, cancelButton: { cancelButtonText: t('BUTTON.CANCEL') } }
          )
          return
        }
        if (branch?.openNotification === '2') {
          if (skippedOverduePatientIdsRef.current.has(pid)) {
            setPatientCase(patientCase)
            setSendExam(true)
          } else {
            setPendingAfterOverdue({ type: 'queue', patientCase })
            setOverduePatientId(pid)
            setOverdueOutstandingBalance(outstanding)
            setOverdueRemark('')
            setIsOpenOverdueModal(true)
          }
        } else {
          setPatientCase(patientCase)
          setSendExam(true)
        }
      }).catch(() => {
        setPatientCase(patientCase)
        setSendExam(true)
      })
    } else if (value.key === 'reloadListQueue' && value.value === 'success') {
      // loadListQueue()
      handleClick()
    }
  }

  const dataAlert = useSelector((state: any) => state.modal.dataAlert)

  // โหลด display pages เมื่อ branchId เปลี่ยน
  useEffect(() => {
    loadDisplayPages()
  }, [branchId])

  // โหลดคิวเมื่อ selectedPage หรือ displayPages เปลี่ยน
  useEffect(() => {
    loadListQueue()
  }, [selectedPage, displayPages])

  const reloadAll = () => {
    loadListQueue()
    loadAllAppointment()
    loadAllDentists()
  }

  useEffect(() => {
    reloadAll()
  }, [dataAlert])

  // ปิด initial loading เมื่อ data critical พร้อม render — รอ load 3 ตัวหลักครั้งแรกเสร็จ
  // ใช้ Promise.allSettled เพื่อให้หน้า home ใช้งานได้แม้บาง API จะ fail/timeout
  useEffect(() => {
    Promise.allSettled([
      loadAllAppointment(),
      loadAllDentists(),
      loadListQueue(),
    ]).finally(() => setIsInitialLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    loadIncome()
  }, [user])

  // แยก effect: handleTimeBranch ขึ้นกับ branchId (primitive) เพื่อไม่ให้ trigger ทุกครั้งที่ user object ใหม่
  useEffect(() => {
    handleTimeBranch(branchId)
  }, [branchId])

  useEffect(() => {
    if (!sendExam) {
      handleCallback({ key: 'reloadListQueue', value: 'success' })
      // loadAllDentists()
    }
  }, [sendExam])
  const handleViewDetail = (val: any) => {
    const temp: any = [...viewDetails]
    if (!temp.find((t: any) => t === val)) temp.push(val)
    setViewDetails(temp)
  }
  const handleCloseDetail = (val: any) => {
    const temp: any = [...viewDetails].filter((t: any) => t !== val)
    setViewDetails(temp)
  }

  const sortAppointmentsByStart = (objApp: any) => {
    const validObjApp = Array.isArray(objApp) ? objApp : [];
    return [...validObjApp].sort((a: any, b: any) => {
      const format = 'HH:mm';
      const aTime = moment(a.start, format);
      const bTime = moment(b.start, format);

      if (!aTime.isValid() || !bTime.isValid()) return 0;
      if (aTime.isBefore(bTime)) return -1;
      if (aTime.isAfter(bTime)) return 1;
      return 0;
    });
  }

  const groupAppointmentByHour = (apt: any) => {
    const validApt = Array.isArray(apt) ? apt : [];
    const newApt: any = _.chain(sortAppointmentsByStart(validApt))
      .groupBy('start')
      .map((value: any) => ({ data: value }))
      .value()
    return newApt
  }

  // memoize เพื่อไม่ให้ sort+groupBy รันใหม่ทุก render เมื่อมี appointment เยอะ
  // pre-compute _allRow per appointment เพื่อตัด _.filter O(n²) ออกจาก inner loop ตอน render
  const groupedAppointments = useMemo(() => {
    const grouped = groupAppointmentByHour(doctor?.appointments)
    return grouped.map((time: any) => {
      const doctorCount = new Map<any, number>()
      for (const item of time.data) {
        doctorCount.set(item.doctorId, (doctorCount.get(item.doctorId) || 0) + 1)
      }
      return {
        ...time,
        data: time.data.map((item: any) => ({ ...item, _allRow: doctorCount.get(item.doctorId) || 1 })),
      }
    })
  }, [doctor?.appointments])
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  function handleClick() {
    forceUpdate();
  }

  const renderDateHome = () => {
    if (i18n.language === 'th') {
      setDateHome(`${t('TIME_DURATION_TYPE.DAY')}${moment().format('dddd')}${t('DAY_AT')} `)
    } else {
      setDateHome(`${moment().format('dddd')} `)
    }
  }

  useEffect(() => {
    renderDateHome()
  }, [i18n.language])

  useEffect(() => {
    if (_.isEmpty(user)) return;
    const controller = new AbortController();

    // รวม operations ที่ค้างอยู่ในรอบ 5s แล้วยิง API แค่ที่จำเป็น
    // ป้องกันกรณี events มาเป็นชุด (เช่นหลายคน check-in ติด ๆ) ทำให้ยิง 4×N calls
    const pendingOps = new Set<string>();
    let flushTimer: NodeJS.Timeout | null = null;

    const flush = () => {
      flushTimer = null;
      const needIncome = pendingOps.has('UPDATED_PAYMENT');
      const needQueue = pendingOps.has('UPDATED_PAYMENT') || pendingOps.has('UPDATED_QUEUE');
      const needAppointment = pendingOps.has('UPDATED_PAYMENT') || pendingOps.has('UPDATED_APPOINTMENT');
      const needDentists = needAppointment;
      pendingOps.clear();

      if (needIncome) loadIncome();
      if (needQueue) loadListQueue();
      if (needAppointment) loadAllAppointment();
      if (needDentists) loadAllDentists();
    };

    BaseAPI.sse(
      (data: { branchId: number; operation: string[] }) => {
        if (data.branchId !== branchId) return;
        let added = false;
        for (const op of ['UPDATED_PAYMENT', 'UPDATED_QUEUE', 'UPDATED_APPOINTMENT']) {
          if (data.operation.includes(op)) {
            pendingOps.add(op);
            added = true;
          }
        }
        if (added && !flushTimer) {
          flushTimer = setTimeout(flush, 5000);
        }
      },
      controller.signal
    );
    return () => {
      controller.abort();
      if (flushTimer) clearTimeout(flushTimer);
    };
  }, [branchId, user]);


  return (
    <div className={'h-100 overflow-hidden'}>
      <Loading show={isInitialLoading} />
      {/* แจ้งเตือนยอดค้างชำระแบบบังคับชำระ (openNotification === '1') - UI เดียวกับหน้าลงทะเบียน */}
      <AlertModal
        isOpen={isOpenOverdueAlert}
        title={t('REGISTER.ALERT.NOTIFICATION_OVERDUE')}
        type='warning'
        handleClose={() => setIsOpenOverdueAlert(false)}
        onCancel={{
          onClick: () => setIsOpenOverdueAlert(false),
          title: t('BUTTON.CANCEL')
        }}
        onSubmit={{
          onClick: () => {
            setIsOpenOverdueAlert(false)
            if (overdueAlertPatientId != null) {
              history.push(routeName.overdueDetail, { patientId: overdueAlertPatientId })
            }
          },
          title: t('BUTTON.SUBMIT')
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Box
            className="pt-2"
            sx={{
              pt: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 0
            }}
          >
            <Typography sx={{ m: 0, p: 0 }} fontSize={14} fontWeight={500}>
              {t('REGISTER.ALERT.PLEASE_PAY_OVERDUE_AMOUNT')}
            </Typography>
            <Typography sx={{ m: 0, p: 0 }} fontSize={14} fontWeight={400}>
              {t('REGISTER.ALERT.PRESS')}{' '}
              <strong>&quot;{t('REGISTER.ALERT.CONFIRM')}&quot;{' '}</strong>
              {t('REGISTER.ALERT.TO_CONTINUE')}
            </Typography>
          </Box>
          <Box
            className="pt-2"
            sx={{
              pt: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px'
            }}
          >
            <Typography fontSize={14} color="#FB5252">
              <strong>{t('REGISTER.ALERT.TOTAL_OVERDUE_AMOUNT')} </strong>&nbsp;
              {numberFormat(overdueAlertBalance)}&nbsp;
              <strong>{t('REGISTER.ALERT.BAHT')}</strong>
            </Typography>
          </Box>
        </Box>
      </AlertModal>
      <CollapseContainer
        key={key.nonUsedKey}
        tooltipExpand={t('HOME.TOOLTIP.EXPAND_SCHEDULE')}
        tooltipShorten={t('HOME.TOOLTIP.SHORTEN_SCHEDULE')}
        styleComponentLeft={{ height: '100%' }}
        styleComponentRight={{ height: '100%' }}
        callBackStatusCollapse={handleCollapse}
        componentLeft={
          <div className={'schedule h-100 py-4 d-flex flex-column'}>
            <UseStyled.Container>
              <UseStyled.TypoHeader className={'text-ellipsis'}>
                <span className={'title-schedule pr-1'}>{t('HOME.TITLE.SCHEDULE')}</span>
                {`${dateHome}`}{toBuddhistYear(moment(), `D MMMM YYYY`)}
              </UseStyled.TypoHeader>
              <div className={'mb-3 mb-xl-4'}>
                <SectionFilterPatient
                  data={appointments}
                  onchange={(event, value: any) => {
                    if (value) handleSelectAppoinment(value)
                    else handleSelectAppoinment('')
                  }}
                  disabled={clinicIsClose}
                  branch={branch}
                />
              </div>
              <div className={'ml-4 mr-2'}>
                <SectionFilterDoctor doctors={doctors} key={key.nonUsedKey ?? 1} filterDoctor={doctor} onClick={(event) => handleSelectDoctor(event)} clinicIsClose={clinicIsClose}></SectionFilterDoctor>
              </div>
            </UseStyled.Container>

            <div className={'h-100 overflow-hidden d-flex flex-row'}>
              <div className={'graph-appointment'} style={{ width: 'calc(100% - 2rem)' }}>
                <SectionAppointment
                  scrollToTime={selectAppoinment ?? ''}
                  timeRange={timeRange}
                  width={"100%"}
                  card={
                    (() => {
                      // ดึงครั้งเดียวก่อน loop แทนเรียก document.querySelector ทุก appointment
                      const containerWidth = (document.querySelector(".container-schedule") as HTMLElement | null)?.clientWidth || 394
                      return _.map(groupedAppointments, (time: any) => {
                        return _.map(time.data, (i: any, indexAppointments: number) => {
                          const allRow = i._allRow || 1
                          const handlePatientCode = () => {
                          if (branch?.patientCodeAppointment === '1') {
                            return i.cnNumber
                          }
                          if (branch?.patientCodeAppointment === '0') {
                            return i.branchCnNumber
                          }
                          if (branch?.patientCodeAppointment === '2') {
                            return i.snCode
                          }
                        }
                        const isRangeEndAfterTimeOut = (rangeText: string, timeOutText: string): boolean => {
                          const [startRaw, endRaw] = rangeText.split(' - ').map(s => s.trim())
                          const start = moment(startRaw.replace(/\./g, ':'), 'HH:mm')
                          const end = moment(endRaw.replace(/\./g, ':'), 'HH:mm')
                          if (!end.isAfter(start)) {
                            end.add(1, 'day')
                          }
                          const timeOut = moment(timeOutText, 'HH:mm')
                          if (timeOut.isBefore(start)) {
                            timeOut.add(1, 'day')
                          }
                          return end.isAfter(timeOut)
                        }

                        return (
                          !_.isEmpty(timeRange) &&
                          (<div key={i.appointmentId}>
                            <CardAppointment
                              appointmentId={i.appointmentId}
                              key={i.appointmentId}
                              serviceText={`${_.map(i.appointmentOperatives, (operative: any, indexOperative: number) => {
                                return `${operative.operativeId ? operative.operativeName : operative.operativeTypeName} `
                              })}`}
                              services={i.appointmentOperatives}
                              showOperativeColor={branch?.showOperativeColor === '1'}
                              rangeTimeText={i.rangeTimeText}
                              colorBackground={i.appointmentOperatives.length === 1 ? i.appointmentOperatives[0].color : colors.white}
                              status={i.statusAppointment}
                              branchCnNumber={handlePatientCode() ? handlePatientCode() : ''}
                              patientFullName={i.patientFullname}
                              displayName={i.displayName}
                              prefixNameEn={i.prefixNameEn}
                              firstnameEn={i.firstnameEn}
                              lastnameEn={i.lastnameEn}
                              start={i.start || i.rangeTimeText.split(' - ')[0].replace('.', ':')}
                              end={
                                isRangeEndAfterTimeOut(i?.rangeTimeText, branch?.timeOut) ? moment(branch?.timeOut, 'HH:mm').add(20, 'minutes').format('HH:mm') : i.end || i.end || i.rangeTimeText.split(' - ')[1].replace('.', ':')
                              }
                              hasLab={i.hasLab === 'HAS'}
                              hasXray={i.hasXray === 'HAS'}
                              timeStart={timeRange[0]}
                              onViewDetail={async () => {
                                const isVitalSign = i?.appointmentOperatives?.find((item: any) => item?.isVitalSign === '1')
                                if (i.statusAppointment !== 'CANCEL' && i.statusAppointment !== 'CANCEL_APP' && i.statusAppointment !== 'DONE') {
                                  await RegisterApi.findPatientFinanceByPatientId(i?.patientId).then(async (financeResp) => {
                                    await RegisterApi.formRegister().then((form) => {
                                      let formRegister = null
                                      let treatmentRegister = null
                                      let vitalSignRegister: any = null
                                      formRegister = JSON.parse(form.data.formRegister)
                                      treatmentRegister = _.find(formRegister.sub, (item: any) => item.id === 'treatment')
                                      vitalSignRegister = _.find(formRegister.sub, (item: any) => item.id === 'vitalSign')
                                      if (branch?.openNotification === '1' && financeResp.data?.outstandingBalance > 0) {
                                        setOverdueAlertPatientId(i?.patientId ?? null)
                                        setOverdueAlertBalance(financeResp.data?.outstandingBalance ?? 0)
                                        setIsOpenOverdueAlert(true)
                                        return
                                      } else if ((isVitalSign && treatmentRegister.isShow && vitalSignRegister.isShow) && (
                                        i.statusAppointment === 'NORMAL' ||
                                        i.statusAppointment === 'CAN_NOT_CONTACT' ||
                                        i.statusAppointment === 'PUT_OFF' ||
                                        i.statusAppointment === 'CONFIRM' ||
                                        i.statusAppointment === 'ARRIVED' ||
                                        i.statusAppointment === 'NOT_YET'
                                      )) {
                                        OperativeApi.findById(isVitalSign?.operativeId).then((operativeResp: any) => {
                                          const isVitalSignById = JSON.parse(operativeResp.data?.isVitalSign)
                                          const hasRequiredAndShow = isVitalSignById?.inputName.some((v: any) =>
                                            v.isRequired &&
                                            vitalSignRegister?.inputName.some((s: any) => s.id === v.id && s.isShow)
                                          );
                                          if (hasRequiredAndShow) {
                                            onSendToRegisterPatientId(i.patientId, isVitalSign)
                                          } else if (branch?.openNotification === '2' && financeResp.data?.outstandingBalance > 0 && !i.vnNumber) {
                                            setPendingAfterOverdue({ type: 'appointment', appointmentId: i.appointmentId })
                                            setOverduePatientId(i.patientId)
                                            setOverdueOutstandingBalance(financeResp.data?.outstandingBalance ?? 0)
                                            setOverdueRemark('')
                                            setIsOpenOverdueModal(true)
                                          } else {
                                            openVisitAppointment(i.appointmentId)
                                          }
                                        })
                                      } else if (!i.cnNumber || !i.branchCnNumber) onSendToRegister(i)
                                      else if (i.statusAppointment === "DONE") handleViewDetail(i.appointmentId)
                                      else if (branch?.openNotification === '2' && financeResp.data?.outstandingBalance > 0 && !i.vnNumber) {
                                        setPendingAfterOverdue({ type: 'appointment', appointmentId: i.appointmentId })
                                        setOverduePatientId(i.patientId)
                                        setOverdueOutstandingBalance(financeResp.data?.outstandingBalance ?? 0)
                                        setOverdueRemark('')
                                        setIsOpenOverdueModal(true)
                                      } else {
                                        openVisitAppointment(i.appointmentId)
                                      }
                                    })

                                  })
                                }
                              }
                              }
                              specialInfo={i?.specialInfo}
                              width={(containerWidth / allRow)}
                              translateX={(containerWidth / allRow) * indexAppointments}
                              phone={i?.phone}
                              allRow={allRow >= 4}
                            />
                          </div>
                          )
                        )
                      })
                    })
                    })()
                  }
                  popup={
                    // render เฉพาะ popup ที่ user เปิดอยู่ ตัด DOM nodes จาก N → 0-K
                    _.map(
                      _.filter(doctor?.appointments, (ap: any) => viewDetailSet.has(ap.appointmentId)),
                      (ap: AppointmentCardItemDayInterface) => (
                        <CardAppointmentDetail
                          key={ap.appointmentId}
                          timeStart={timeRange[0]}
                          timeEnd={timeRange[timeRange.length - 1]}
                          appointmentId={ap.appointmentId}
                          showPopup={true}
                          onClose={handleCloseDetail}
                          onEdit={undefined}
                          hideMenu={true}
                          onEditSpecialInfo={undefined}
                          status={ap.statusAppointment}
                          branch={branch} />
                      )
                    )
                  }
                  showMinute
                />
              </div>
            </div>
          </div>
        }
        componentRight={
          <div className={'service-points h-100 pb-4 d-flex flex-column'} >
            <UseStyled.Container>
              <UseStyled.Header className={'d-flex align-items-center'} style={{ flexWrap: 'wrap', gap: '8px' }}>
                {checkAddons(PACKAGE_ADDONS.ADDON_BRANCH_PAGE_LAYER) &&
                  <>
                    <UseStyled.TypoHeader className={'text-ellipsis mb-0'} style={{ fontSize: '16px' }}>{t('HOME.TITLE.SERVICE_POINTS')}</UseStyled.TypoHeader>
                    {/* Display Page Selector - อยู่ในบรรทัดเดียวกับหัวข้อ */}
                    {displayPages.length > 1 && (
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <div
                          onClick={() => setSelectedPage(0)}
                          style={{
                            padding: '4px 10px',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: selectedPage === 0 ? 600 : 400,
                            backgroundColor: selectedPage === 0 ? colors.themeSecondColor : colors.lightGray,
                            color: selectedPage === 0 ? colors.white : colors.textPrimary,
                            transition: 'all 0.2s ease'
                          }}
                        >
                          {t('ALL')}
                        </div>
                        {displayPages.map((page) => (
                          <div
                            key={page.pageNumber}
                            onClick={() => setSelectedPage(page.pageNumber)}
                            style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: selectedPage === page.pageNumber ? 600 : 400,
                              backgroundColor: selectedPage === page.pageNumber ? colors.themeSecondColor : colors.lightGray,
                              color: selectedPage === page.pageNumber ? colors.white : colors.textPrimary,
                              transition: 'all 0.2s ease'
                            }}
                          >
                            {i18n.language === 'en' && page.pageNameEn ? page.pageNameEn : page.pageName}
                            {/* ({page.servicePointCount}) */}
                          </div>
                        ))}
                      </div>
                    )}
                  </>}
                {canViewIncome && (
                  <UseStyled.Income style={{ marginLeft: 'auto' }}>
                    <span className={'pr-1'}>{t('HOME.TITLE.INCOME')}</span>
                    <span className={'ml-auto'}>{numberFormat(income)}</span>
                    <span className={'pl-1'}>{t('HOME.TITLE.CURRENCY')}</span>
                  </UseStyled.Income>
                )}
              </UseStyled.Header>
            </UseStyled.Container>
            {/* overflow-hidden */}
            <UseStyled.Container className={'pr-0 h-100 '} style={{ position: 'relative' }}>
              <SectionServicePoints
                branch={branch}
                service={servicePoints}
                hasCollapse={hasCollapse}
                setCancelCase={handleCallback}
                setPatientCase={handleCallback}
                reRender={reloadAll}
              />
            </UseStyled.Container>
          </div >
        }
      ></CollapseContainer >
      {sendExam && <SendExamination isShow={sendExam} setIsShow={(show: boolean) => setSendExam(show)} patient={patientCase} type={'home'} service={servicePoints} onReloadQueue={loadListQueue} />}

      <PageModal
        isOpen={isOpenOverdueModal}
        title={``}

        size='XS'
        handleClose={() => {
          setIsOpenOverdueModal(false)
          setOverdueRemark('')
          setPendingAfterOverdue(null)
        }}
        onCancel={{
          onClick: () => {
            setIsOpenOverdueModal(false)
            setOverdueRemark('')
            setPendingAfterOverdue(null)
          }
        }}
        onSubmit={{
          onClick: async () => {
            if (!overdueRemark.trim() || overduePatientId == null || !pendingAfterOverdue) return
            setIsOpenOverdueModal(false)
            const remark = overdueRemark
            setOverdueRemark('')
            const pending = pendingAfterOverdue
            setPendingAfterOverdue(null)
            try {
              await RegisterApi.postOutstandingBalanceRemark({ patientId: overduePatientId, remark })
            } catch (e) {
              console.error('Failed to save overdue remark:', e)
            }
            skippedOverduePatientIdsRef.current.add(overduePatientId)
            if (pending.type === 'appointment') {
              openVisitAppointment(pending.appointmentId)
            } else {
              setPatientCase(pending.patientCase)
              setSendExam(true)
            }
          },
          title: 'ข้ามการชำระครั้งนี้',
          width: 145,
          disabled: !overdueRemark.trim()
        }}
        btnLeft={{
          onClick: () => {
            setIsOpenOverdueModal(false)
            setOverdueRemark('')
            setPendingAfterOverdue(null)
            if (overduePatientId != null) history.push(routeName.overdueDetail, { patientId: overduePatientId })
          },
          title: 'ชำระยอดค้าง'
        }}
      >
        <>
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="8px">
            <Box sx={{ width: 60, height: 60, display: 'inline-flex', '& svg': { width: '100%', height: '100%' } }}>
              <Icons.WarningCircle firstFill="#FFC42E" secondFill="#FFC42E" />
            </Box>
            <Box
              sx={{
                textAlign: "center",
                color: "#2F4269",
                fontSize: "20px",
                fontWeight: 600,
                flex: 1,
              }}
            >
              {t('REGISTER.ALERT.NOTIFICATION_OVERDUE')}
            </Box>
            <Typography fontSize={14} fontWeight={600}>พบยอดค้างชำระในระบบ กรุณาเลือกดำเนินการ</Typography>
            <Typography fontSize={18} fontWeight={800} color="#FB5252">ยอดค้างชำระรวม {numberFormat(overdueOutstandingBalance)} {t('REGISTER.ALERT.BAHT')}</Typography>
          </Box>
          <Typography fontSize={14} fontWeight={600} paddingBottom="4px" paddingTop="16px">หมายเหตุ (เหตุผลในการข้ามการชำระครั้งนี้)*</Typography>
          <TextAreaInput
            rows={3}
            fullWidth
            value={overdueRemark}
            onChange={(e) => setOverdueRemark(e.target.value)}
            maxLength={500}
            required
            inputProps={{
              style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', fontSize: '12px' },
              startAdornment: (
                <Box sx={{ position: 'absolute', bottom: '2px' }}>
                  <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${overdueRemark?.length || 0}/500`}</Box>
                </Box>
              ),
            }}
          />
        </>
      </PageModal>

      {/* <div style={{ display: "none" }}>
        <ModalCustomNotification />
      </div> */}

    </div >
  )
}
